import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

// Components
import NavTabs from './NavTabs';

// Helpers
import actions from '../../actions/FavoritesActions';

// Styles
import styles from './styles/Nav.scss';

const Nav = ({ navBorder, projectsEnabled = false, setRouterNavigation, slideNavBorder }) => {
    const setBorder = event => {
        setRouterNavigation(false);
        slideNavBorder({ width: event.target.offsetWidth, x: event.target.offsetLeft });
    };

    const borderStyle = {
        transform: `translate3d(${navBorder.x}px, 0, 0)`,
        width: navBorder.width,
    };

    return (
        <PageLayout setViewportBackground={'sassyColorBuyerTertiary'}>
            <div className={styles.content}>
                <div className={styles.title}>My Favorites</div>
                <NavTabs
                    setBorder={setBorder}
                    borderStyle={borderStyle}
                    projectsEnabled={projectsEnabled}
                />
            </div>
        </PageLayout>
    );
};

const mapStateToProps = state => {
    return {
        navBorder: state.favorites.uiState.navBorder,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setRouterNavigation: routerNavigation => {
            dispatch(actions.routerNavigation({ routerNavigation }));
        },
        slideNavBorder: navBorder => {
            dispatch(actions.slideNavBorder({ navBorder }));
        },
    };
};

Nav.propTypes = {
    navBorder: PropTypes.object,
    projectsEnabled: PropTypes.bool,
    setRouterNavigation: PropTypes.func,
    slideNavBorder: PropTypes.func,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Nav);
